var _path, _path2, _path3, _path4, _path5, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToMinorAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M19.6 25.8h-4.8s-2.6.2-4.7-2.3C7.6 20.2 5 20.4 5 20.4H2.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M19.5 25.8h-4.8s-2.6-.2-4.7 2.3c-2.5 3.3-5.1 3.1-5.1 3.1H2.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M15 21.2l4.6 4.6-4.6 4.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M20.2 33.9l4.9 2.3 14.6-6.5V12.4M39.7 12.4L25 6.9 10.1 13v3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M10.1 13l15.1 5.5 14.5-6.1M25.2 18.9v15.6M29.9 22.1l5.2-2.2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 29.9,
    cy: 27,
    r: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToMinorAsset);
export default __webpack_public_path__ + "static/media/addToMinorAsset.b7be1d4405eb18f8f96449bff4b8ff79.svg";
export { ForwardRef as ReactComponent };